var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrows = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 56,
    viewBox: "0 0 80 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.879 29.274H3.109A3.107 3.107 0 0 0 0 32.38v19.516A3.107 3.107 0 0 0 3.11 55h17.769c1.717 0 3.11-1.39 3.11-3.105V32.38a3.107 3.107 0 0 0-3.11-3.105Z",
    stroke: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.639 31.1H3.349c-.858 0-1.554.694-1.554 1.551v17.606c0 .857.696 1.552 1.555 1.552h17.289c.858 0 1.554-.695 1.554-1.552V32.652c0-.858-.696-1.553-1.554-1.553Z",
    stroke: "#fff",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.435 41.693a.444.444 0 1 0 0-.887v.887Zm-8.884-.443 4.442 2.56V38.69l-4.442 2.56Zm8.884-.444H11.55v.887h4.886v-.887Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.42 29.274H30.65a3.107 3.107 0 0 0-3.109 3.105v19.516A3.107 3.107 0 0 0 30.651 55H48.42c1.717 0 3.11-1.39 3.11-3.105V32.38a3.107 3.107 0 0 0-3.11-3.105Z",
    stroke: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.182 31.1h-17.29c-.858 0-1.554.694-1.554 1.551v17.606c0 .857.696 1.552 1.555 1.552h17.289c.858 0 1.554-.695 1.554-1.552V32.652c0-.858-.696-1.553-1.554-1.553Z",
    stroke: "#fff",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.98 36.815a.444.444 0 0 0-.889 0h.889Zm-.444 8.87L42.1 41.25h-5.13l2.565 4.436Zm-.445-8.87v4.879h.889v-4.88h-.889Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.42 0H30.65a3.107 3.107 0 0 0-3.109 3.105V22.62a3.107 3.107 0 0 0 3.11 3.105H48.42c1.717 0 3.11-1.39 3.11-3.105V3.105A3.107 3.107 0 0 0 48.42 0Z",
    stroke: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.182 1.825h-17.29c-.858 0-1.554.695-1.554 1.553v17.605c0 .857.696 1.552 1.555 1.552h17.289c.858 0 1.554-.695 1.554-1.552V3.378c0-.858-.696-1.553-1.554-1.553Z",
    stroke: "#fff",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.091 16.412a.444.444 0 0 0 .889 0h-.889Zm.445-8.871-2.565 4.435h5.13l-2.565-4.435Zm.444 8.87v-4.879h-.889v4.88h.889Z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.963 29.274h-17.77a3.107 3.107 0 0 0-3.109 3.105v19.516A3.107 3.107 0 0 0 58.194 55h17.769c1.717 0 3.11-1.39 3.11-3.105V32.38a3.107 3.107 0 0 0-3.11-3.105Z",
    stroke: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.723 31.1h-17.29c-.858 0-1.554.694-1.554 1.551v17.606c0 .857.696 1.552 1.555 1.552h17.289c.858 0 1.554-.695 1.554-1.552V32.652c0-.858-.696-1.553-1.554-1.553Z",
    stroke: "#fff",
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.638 40.806a.444.444 0 1 0 0 .887v-.887Zm8.884.444-4.442-2.561v5.122l4.442-2.561Zm-8.884.443h4.886v-.887h-4.886v.887Z",
    fill: "#fff"
  })));
};
export { SvgArrows as ReactComponent };